import { useEffect } from 'react' 
const KEYBOARD_HEIGHT_THRESHOLD = 150

const UseViewportPadding = (enabled = true) => {

    useEffect(()=>{
        const ua = navigator.userAgent
        const iOS =
            /iPad|iPhone|iPod/.test(ua) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        if (!iOS) return
        document.body.classList.add("mobile")
        const viewport = window.visualViewport
        if (!viewport) return

        const reset = () => {
            const board = document.getElementById("content")
            if (!board) return
            board.style.paddingBottom = "" 
            document.body.classList.remove("keyboard-open")
        }

        const handlePadding = () => {
            if (!enabled) return
            const board = document.getElementById("content")
            if (!board) return
            let prevHeight = document.documentElement.clientHeight
            let currentHeight = viewport.height
            let keyboardHeight = Math.max(0,prevHeight-currentHeight)
            if (keyboardHeight >= KEYBOARD_HEIGHT_THRESHOLD){
                board.style.paddingBottom = `${keyboardHeight}px`
            }
            else{
                reset()
            } 
        }

        handlePadding()

        viewport.addEventListener("resize",handlePadding)
        return () => {
            viewport.removeEventListener("resize",handlePadding)
            document.body.classList.remove("mobile")
            reset()
        } 
    },[enabled])

    return
}

export default UseViewportPadding